import { Component, inject, input, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { MultiImagesStorageService } from '../../services/multi-images-storage.service';
import { FileStorageData } from '../../classes/storage.models';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { MoodStateOptions } from '@dataclouder/ngx-core';

@Component({
  selector: 'dc-simple-uploader',
  templateUrl: './simple-uploader.component.html',
  styleUrls: ['./simple-uploader.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, ButtonModule, TooltipModule, DialogModule, InputTextModule, SelectModule],
})
export class SimpleUploaderComponent {
  private multiImagesStorageService = inject(MultiImagesStorageService);

  storagePath = input.required<string>();
  buttonLabel = input<string>('Upload File');
  accept = input<string>('*/*');
  disabled = input<boolean>(false);
  metadata = input<any>({});

  fileUploaded = output<FileStorageData>();
  uploadError = output<any>();

  isLoading = signal(false);
  displayDialog = signal(false);
  fileSelected = signal<File | null>(null);
  moodSelected = signal<string | null>(null);
  fileInputId: string;
  metadataInput: any = {};
  public MoodStateOptions = MoodStateOptions;

  constructor() {
    this.fileInputId = `file-upload-${Math.random().toString(36).substring(2, 11)}`;
  }

  objectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  openDialog(): void {
    this.metadataInput = { ...this.metadata() };
    this.displayDialog.set(true);
  }

  triggerFileInputClick(fileInput: HTMLInputElement): void {
    fileInput.click();
  }

  onFileSelected(event: Event): void {
    const fileInput = event.target as HTMLInputElement;
    const file = fileInput.files?.[0];
    if (file) {
      this.fileSelected.set(file);
    }
  }

  async uploadFile(): Promise<void> {
    const file = this.fileSelected();
    if (file) {
      this.isLoading.set(true);
      const metadata = {
        // ...this.metadataInput,
        moodState: this.moodSelected(),
      };
      try {
        const result = await this.multiImagesStorageService.uploadGenericFile(file, this.storagePath(), metadata);
        result.metadata = metadata;
        if (result) {
          this.fileUploaded.emit(result);
        } else {
          this.uploadError.emit({ error: 'Upload failed and no specific error was provided by the service.' });
        }
      } catch (error) {
        console.error('Error during file upload in SimpleUploaderComponent:', error);
        this.uploadError.emit(error);
      } finally {
        this.isLoading.set(false);
        this.displayDialog.set(false);
        this.fileSelected.set(null);
        this.moodSelected.set(null);
      }
    }
  }
}
